import BaseHeadBanner from "../../../components/elements/BaseHeadBanner"
import BasePage from "../../../components/layout/BasePage"
import BaseButtonRow from "../../../components/elements/BaseButtonRow"
import BaseGrowBody from "../../../components/elements/BaseGrowBody"
import ReportsTable from "../components/ReportsTable"
import { useQuery } from "@tanstack/react-query"
import { getPaginatedData } from "../../api/apiCalls"
import { useMemo, useState } from "react"
import { getDataFromSessionStorage, useDelayWhenSearchWithPagination } from "../../../services/functions"
import BaseInputSearch from "../../../components/elements/BaseInputSearch"
import ErrorPage from "../../404/ErrorPage"
import Loading from "../../../components/common/Loading"
import { Pagination } from "antd"
import { LocalStorageKeys, GeneralQueryKeys } from "../../../api/constants"
import { ReportWithRelationsType } from "../types"

export default function ReportsPage() {

    // GET Reports
    const [page, setPage] = useState<number>(getDataFromSessionStorage(LocalStorageKeys.REPORT_FILTER + "page") ?? 1)
    const handlePageChange = (page: number) => {
        sessionStorage.setItem(LocalStorageKeys.REPORT_FILTER + "page", JSON.stringify(page))
        setPage(page)
    }
    const [searchTermReports, setSearchTermReports] = useState(getDataFromSessionStorage(LocalStorageKeys.REPORT_FILTER + "searchTerm"))
    const searchParamsReports = useDelayWhenSearchWithPagination(searchTermReports, LocalStorageKeys.REPORT_FILTER + "searchTerm")
    const queryKeyReports = GeneralQueryKeys.REPORT + searchParamsReports
    const {
        error: allReportsError,
        isLoading: allReportsIsLoading,
        data: allReportsData,
    } = useQuery({
        queryKey: [queryKeyReports],
        queryFn: () =>
            getPaginatedData({
                pageType: "report",
                page: page,
                limit: 20,
                search: searchParamsReports,
            }),
    })
    const displayedReports = useMemo(() => allReportsData?.docs, [allReportsData?.docs])

    if (allReportsError) return <ErrorPage />
    if (allReportsIsLoading) return <Loading />

    return (    
        <BasePage>
            <BaseHeadBanner title={"Berichte"} />
            <BaseButtonRow>
                <div className="flex gap-2 items-center">
                    <BaseInputSearch placeholder={"Berichte suchen..."} hidden="hidden lg:flex" searchTerm={searchTermReports} setsearchTerm={setSearchTermReports} />
                </div>
            </BaseButtonRow>
            <BaseGrowBody>
                <ReportsTable reports={displayedReports as ReportWithRelationsType[]} searchTerm={searchParamsReports} />
                {allReportsData.totalPages > 1 && (
                    <div className="flex justify-center mt-4">
                        <Pagination current={page} total={allReportsData.totalDocs} pageSize={20} onChange={handlePageChange} showSizeChanger={false} />
                    </div>
                )}
            </BaseGrowBody>
        </BasePage>
    )
}
